import { getOrderNumberSuffix } from '@/utils/markerUtils';
import { offlineCoordinateForOrder } from '@/utils/offlineMapProjection';

export const isLocalOrder = (order) => order?.desktop_sync?.origin === 'local';

export const stopOrderId = (stop = {}) => (
  stop.order_id
  || stop.orderId
  || stop.order_ref?.resolved_cloud_order_id
  || stop.order_ref?.order_id
  || stop.resolved_order?.order_ref?.resolved_cloud_order_id
  || stop.resolved_order?.order_ref?.order_id
  || stop.resolved_order?.order?.id
  || stop.order?.id
  || stop.order?._id
);

export const orderLookupKeys = (order = {}) => [
  order.id,
  order._id,
  order.order_id,
  order.cloud_order_id,
  order.desktop_sync?.cloud_order_id,
].filter(Boolean).map(String);

export const orderHasRouteCoordinate = (order) => Boolean(offlineCoordinateForOrder(order));

const PLACEABLE_LOCAL_STATUSES = new Set(['accepted', 'designed']);

export function classifyManualOrderPlacement(order = {}) {
  const local = isLocalOrder(order);
  const placed = local && orderHasRouteCoordinate(order);
  const placementStatus = PLACEABLE_LOCAL_STATUSES.has(order.status);

  return {
    isLocal: local,
    isPlaced: placed,
    needsPlacement: local && placementStatus && !placed,
    isDispatchReady: order.status === 'designed' && (!local || placed),
  };
}

export function buildOfflineStopInfoMap(selectedRun) {
  const map = new Map();
  selectedRun?.populated_stops?.forEach((stop) => {
    const orderId = stopOrderId(stop);
    if (!orderId) return;
    map.set(String(orderId), {
      sequence: stop.sequence,
      orderSuffix: getOrderNumberSuffix(
        stop.order?.internal_order_number || stop.internal_order_number,
      ),
    });
  });
  return map;
}

export function hydrateOfflineRunStops(selectedRun, orders = []) {
  const orderById = new Map();
  orders.forEach((order) => {
    orderLookupKeys(order).forEach((key) => orderById.set(key, order));
  });

  return (selectedRun?.populated_stops || []).map((stop) => {
    const orderId = stopOrderId(stop);
    const embeddedOrder = stop.order || stop.resolved_order?.order;
    const currentOrder = orderId ? orderById.get(String(orderId)) : null;
    const order = (
      embeddedOrder && orderHasRouteCoordinate(embeddedOrder)
        ? embeddedOrder
        : currentOrder || embeddedOrder
    );

    return {
      ...stop,
      order_id: stop.order_id || orderId,
      order,
    };
  });
}

export function routeStopSignature(selectedRun) {
  return (selectedRun?.populated_stops || [])
    .map((stop) => {
      const orderId = stopOrderId(stop) || 'unknown';
      const coordinate = offlineCoordinateForOrder(stop.order);
      return [
        stop.sequence ?? '',
        orderId,
        coordinate?.latitude ?? '',
        coordinate?.longitude ?? '',
      ].join(':');
    })
    .join('|');
}
